import type { ComponentType, SVGProps } from 'react';

type SvgImport = () => Promise<{ default: ComponentType<SVGProps<SVGSVGElement>> }>;

export const FLAGS: Record<string, SvgImport> = {
  ae: () => import('assets/countryFlags/ae.svg?react'),
  am: () => import('assets/countryFlags/am.svg?react'),
  at: () => import('assets/countryFlags/at.svg?react'),
  au: () => import('assets/countryFlags/au.svg?react'),
  az: () => import('assets/countryFlags/az.svg?react'),
  ba: () => import('assets/countryFlags/ba.svg?react'),
  be: () => import('assets/countryFlags/be.svg?react'),
  bg: () => import('assets/countryFlags/bg.svg?react'),
  bj: () => import('assets/countryFlags/bj.svg?react'),
  bm: () => import('assets/countryFlags/bm.svg?react'),
  bn: () => import('assets/countryFlags/bn.svg?react'),
  br: () => import('assets/countryFlags/br.svg?react'),
  ca: () => import('assets/countryFlags/ca.svg?react'),
  ch: () => import('assets/countryFlags/ch.svg?react'),
  cn: () => import('assets/countryFlags/cn.svg?react'),
  co: () => import('assets/countryFlags/co.svg?react'),
  cy: () => import('assets/countryFlags/cy.svg?react'),
  cz: () => import('assets/countryFlags/cz.svg?react'),
  de: () => import('assets/countryFlags/de.svg?react'),
  dk: () => import('assets/countryFlags/dk.svg?react'),
  ee: () => import('assets/countryFlags/ee.svg?react'),
  es: () => import('assets/countryFlags/es.svg?react'),
  eu: () => import('assets/countryFlags/eu.svg?react'),
  fi: () => import('assets/countryFlags/fi.svg?react'),
  fr: () => import('assets/countryFlags/fr.svg?react'),
  gb: () => import('assets/countryFlags/gb.svg?react'),
  ge: () => import('assets/countryFlags/ge.svg?react'),
  gi: () => import('assets/countryFlags/gi.svg?react'),
  gg: () => import('assets/countryFlags/gg.svg?react'),
  gh: () => import('assets/countryFlags/gh.svg?react'),
  gr: () => import('assets/countryFlags/gr.svg?react'),
  hk: () => import('assets/countryFlags/hk.svg?react'),
  hr: () => import('assets/countryFlags/hr.svg?react'),
  hu: () => import('assets/countryFlags/hu.svg?react'),
  ie: () => import('assets/countryFlags/ie.svg?react'),
  in: () => import('assets/countryFlags/in.svg?react'),
  is: () => import('assets/countryFlags/is.svg?react'),
  it: () => import('assets/countryFlags/it.svg?react'),
  jo: () => import('assets/countryFlags/jo.svg?react'),
  jp: () => import('assets/countryFlags/jp.svg?react'),
  kr: () => import('assets/countryFlags/kr.svg?react'),
  kw: () => import('assets/countryFlags/kw.svg?react'),
  kz: () => import('assets/countryFlags/kz.svg?react'),
  lb: () => import('assets/countryFlags/lb.svg?react'),
  li: () => import('assets/countryFlags/li.svg?react'),
  lk: () => import('assets/countryFlags/lk.svg?react'),
  lt: () => import('assets/countryFlags/lt.svg?react'),
  lu: () => import('assets/countryFlags/lu.svg?react'),
  lv: () => import('assets/countryFlags/lv.svg?react'),
  mc: () => import('assets/countryFlags/mc.svg?react'),
  mt: () => import('assets/countryFlags/mt.svg?react'),
  mu: () => import('assets/countryFlags/mu.svg?react'),
  mx: () => import('assets/countryFlags/mx.svg?react'),
  mo: () => import('assets/countryFlags/mo.svg?react'),
  my: () => import('assets/countryFlags/my.svg?react'),
  ng: () => import('assets/countryFlags/ng.svg?react'),
  nl: () => import('assets/countryFlags/nl.svg?react'),
  no: () => import('assets/countryFlags/no.svg?react'),
  ph: () => import('assets/countryFlags/ph.svg?react'),
  pl: () => import('assets/countryFlags/pl.svg?react'),
  pr: () => import('assets/countryFlags/pr.svg?react'),
  pt: () => import('assets/countryFlags/pt.svg?react'),
  qa: () => import('assets/countryFlags/qa.svg?react'),
  ro: () => import('assets/countryFlags/ro.svg?react'),
  rs: () => import('assets/countryFlags/rs.svg?react'),
  sa: () => import('assets/countryFlags/sa.svg?react'),
  se: () => import('assets/countryFlags/se.svg?react'),
  sg: () => import('assets/countryFlags/sg.svg?react'),
  si: () => import('assets/countryFlags/si.svg?react'),
  sk: () => import('assets/countryFlags/sk.svg?react'),
  sl: () => import('assets/countryFlags/sl.svg?react'),
  th: () => import('assets/countryFlags/th.svg?react'),
  tj: () => import('assets/countryFlags/tj.svg?react'),
  tr: () => import('assets/countryFlags/tr.svg?react'),
  tw: () => import('assets/countryFlags/tw.svg?react'),
  us: () => import('assets/countryFlags/us.svg?react'),
  uz: () => import('assets/countryFlags/uz.svg?react'),
  zm: () => import('assets/countryFlags/zm.svg?react'),
} satisfies Record<string, SvgImport>;

export type FlagCode = keyof typeof FLAGS;
